export default __webpack_public_path__ + "static/media/cryptocrispyLogo.0141ccce.png";